'use client';

import { lazy } from 'react';
import type { TravelAgencyToursProps } from './travel-agency-tours-runtime';
export type { TravelAgencyToursProps } from './travel-agency-tours-runtime';

const Tours = lazy(() =>
  import('./travel-agency-tours-runtime').then(m => ({ default: m.TravelAgencyTours })),
);
const ToursInner = lazy(() =>
  import('./travel-agency-tours-runtime').then(m => ({ default: m.TravelAgencyToursInner })),
);

// No local null fallback and no ssr:false: preserve server content and the
// existing route transition boundary. Export functions, not nested lazy objects.
export function TravelAgencyTours(props: TravelAgencyToursProps) {
  return <Tours {...props} />;
}

export function TravelAgencyToursInner(props: TravelAgencyToursProps) {
  return <ToursInner {...props} />;
}
